import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CalendarService } from '../../../../../app/services/calendar.service';
import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';
import { DataPackCalendar } from '../../../../../app/models/dataPackCalendar.model';

  import * as _ from "lodash";
import { DataPackLine } from '../../../../models/start';

/**
 * @version $Id: content.component.ts 82300 2018-03-15 18:11:43Z bernardo.d.siqueira $
 */
@Component({
  selector: 'unsetCalendarModal',
  templateUrl: './content.template.html'
})
export class UnsetCalendarModalComponent {

	@Input() group: DataPackGroup;
  @Input() lines: Array<DataPackLine>;

  private removing: boolean;

  constructor(private activeModal: NgbActiveModal, private calendarService: CalendarService, private alertService: AlertService) {

  }

  private close() {
    this.activeModal.dismiss();
  }

  private remove() {
    this.removing = true;
    let payload: any = {
      group: { id: this.group.id },
      lines: _.map(this.lines, (line) => {
    	return _.pick(line, ['lineNumber', 'account', 'calendar', 'userName'])
      })
    };
    this.calendarService.unsetCalendar(payload).subscribe(
      data => {
        this.removing = false;
        this.alertService.success(data['result']);
        this.activeModal.close();
      },
      err => {
        this.removing = false;
        this.alertService.error(err.result, err);
        this.activeModal.dismiss();
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/calendar/unset/content.component.ts